export const shallowEqual = (x: any, y: any) => {
    // check if any of the params is null
    if (x === null || y === null || typeof(x) !== 'object' || typeof(y) !== 'object') { return x === y }

    // compare if params are arrays
    if (Array.isArray(x)) {
        if (Array.isArray(y)) {
            // compare arrays
        } else {
            return false
        }
    }

    // compare if params are objects
    const keysX = Object.keys(x)
    const keysY = Object.keys(y)

    if (keysX.length !== keysY.length) { return false }

    for (let key of keysX) {
        if (x[key] !== y[key]) { return false }
    }

    return true
}
